import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class MobileVerifiedGuardService {

  constructor(private auth : AuthService, private messageService: MessageService) { }
  canActivate():boolean{
    if(this.auth.user.country_id==233 && this.auth.user.verified && this.auth.user.email_verified_at){
      return true
    }
    else if(this.auth.user.country_id==39 && this.auth.user.mob_verified && this.auth.user.email_verified_at){
      return true
    }
    else{
      this.messageService.add({severity:'error', summary:'Update account first', detail:''});
      return false
    }
  }
}
